import React from "react";
import Spinner from "./ui/Spinner";

// Shared centered loading indicator used across pages and sections.
const Loader = ({ label = "Loading…" }) => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 py-16">
      <Spinner size="lg" />
      <p className="text-sm text-muted">{label}</p>
    </div>
  );
};

export default Loader;
